import React from 'react';
import { Control, Controller, FieldErrors, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { IconCircleArrowDown } from '@tabler/icons-react';

// Asumsi komponen ini diimpor dari path yang benar
import CurrencyInput from '../../../../shared/components/form/CurrencyInput';
// Import tipe form utama untuk pengetikan yang kuat
import { CreateBookingFormV4 } from '../../../../services/create-booking-v4/schema/CreateBookingSchemaV4';

// Tipe untuk satu baris rate
interface RateRow {
    date: string;
    rate: number;
}

// Tipe untuk props komponen
interface RateTabPropsV4 {
    index: number;
    control: Control<CreateBookingFormV4>;
    watch: UseFormWatch<CreateBookingFormV4>;
    setValue: UseFormSetValue<CreateBookingFormV4>;
    errors: FieldErrors<CreateBookingFormV4>;
}

const RateTabComponentV4: React.FC<RateTabPropsV4> = ({ index, control, watch, setValue, errors }) => {

    // Mengambil data tarif untuk kamar saat ini
    const rates = watch(`bookingroom.${index}.rates`);

    console.log('watch rates:', rates);

    // Fungsi untuk menyalin tarif pertama ke semua baris
    const handleCopyRate = () => {
        if (!rates || rates.length === 0) return;

        const firstRateValue = rates[0].rate;
        const updatedRates = rates.map((rate: RateRow) => ({
            ...rate,
            rate: firstRateValue
        }));

        setValue(`bookingroom.${index}.rates`, updatedRates, { shouldDirty: true });
    };

    return (
        <div className="d-flex flex-column" style={{ height: "100%" }}>
            <div className="action-sheet-content flex-grow-1">
                <div className="row mb-3 align-items-start">
                    <div className="table-responsive">
                        <table className="table table-bordered table-striped">
                            <thead className="thead-light">
                                <tr>
                                    <th>DATE</th>
                                    <th style={{ width: '250px' }}>RATE</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rates && rates.map((row: RateRow, rowIndex: number) => (
                                    // <tr key={`${row.date}-${row.rate}-${rowIndex}`}>
                                    <tr key={row.date}>
                                        <td className="d-flex justify-content-between align-items-center">
                                            <span>{row.date}</span>
                                            {rowIndex === 0 && (
                                                <button
                                                    type="button"
                                                    className="p-0 bg-transparent border-0 text-primary"
                                                    onClick={handleCopyRate}
                                                    title="Copy this rate to all dates below"
                                                >
                                                    <IconCircleArrowDown size={20} />
                                                </button>
                                            )}
                                        </td>
                                        <td>
                                            <Controller
                                                name={`bookingroom.${index}.rates.${rowIndex}.rate`}
                                                control={control}
                                                render={({ field }) => (
                                                    <CurrencyInput
                                                        name={field.name}
                                                        className={errors.bookingroom?.[index]?.rates?.[rowIndex]?.rate ? 'form-control is-invalid' : 'form-control'}
                                                        value={Number(field.value) || 0}
                                                        onChange={(_event, rawValue) => {
                                                            field.onChange(rawValue);
                                                        }}
                                                    />
                                                )}
                                            />
                                            {errors.bookingroom?.[index]?.rates?.[rowIndex]?.rate && (
                                                <span className="text-danger small mt-1">
                                                    {errors.bookingroom[index].rates[rowIndex].rate?.message}
                                                </span>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RateTabComponentV4;